export default __webpack_public_path__ + "static/6841-593d7b21aafdfe659c6187e7af8f8a30.jpg";